<template>
  <form :class="['wizard', preloader || btnLoader ? 'is-loading' : '']">
    <preloader v-if="preloader"></preloader>
    <div
      class="wizard-message"
      v-else-if="wizardMsgScreen"
      v-html="wizardMsgScreen"
    ></div>
    <template v-else>
      <div class="flex flex-column w100 f50">
        <div :class="['container__sm']" class="flex-child">
          <slot name="wizard-links"> </slot>

          <slot name="wizard-title">
            <h2 v-if="title" class="page-title pb-s">
              <span v-text="title"></span>
              <template v-if="titleNote">
                <span v-text="titleNote"></span>
              </template>
            </h2>
          </slot>
        </div>
        <div :class="['container__sm']" class="mb-xl">
          <slot name="wizard-nav"></slot>
        </div>
      </div>
      <div class="rel" ref="wizard-step-wrap">
        <!-- :class="[wizardStepSize ? 'container__' + wizardStepSize : 'container']" -->
        <slot name="wizard-steps"></slot>

        <div class="btn-bar">
          <div
            class=" flex flex-column justify-end align-end py-m rel"
            :class="[
              wizardStepSize ? 'container__' + wizardStepSize : 'container'
            ]"
          >
            <div
              v-if="log"
              :class="[
                'action-log',
                'flex',
                'align-center',
                `log--${log.type}`
              ]"
            >
              <preloader v-if="log.icon === 'preloader'" inline></preloader>
              <i v-else-if="log.icon" :class="[log.icon, 'mr-s']"></i>
              <span v-text="log.txt"></span>
            </div>
            <div class="flex align-end justify-center mb-m">
              <button
                v-if="activeStep > 0"
                class="btn btn-info rounded"
                @click.prevent="lastStep"
              >
                {{localize('back')}}
              </button>
              <button
                class="btn btn-primary rounded mx-m flex align-center justify-center"
                @click.prevent="nextStep">
                <preloader v-if="btnLoader" inline color="white"></preloader>
                <!-- <i class="fal fa-spinner fa-spin" v-if="btnLoader"></i> -->
                <span
                  :class="btnLoader ? 'mx-s' : ''"
                  v-text="
                    nextStepLabel ||
                      (activeStep === totalSteps ? 
                      localize('sign_up') : localize('next').toUpperCase())
                  "
                ></span>
              </button>
            </div>

            <slot class="flex" name="actions"></slot>
          </div>
        </div>
      </div>
    </template>

    <slot name="out-of-box"></slot>
  </form>
</template>

<script>
export default {
  props: {
    wizardMsgScreen: {
      type: String,
      default: null
    },
    preloader: {
      type: Boolean,
      default: false
    },
    btnLoader: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
    titleNote: {
      type: String,
      default: null
    },
    log: {
      type: Object,
      default: null
    },
    wizardStepSize: String,
    activeStep: Number,
    totalSteps: Number,
    nextStepLabel: String
  },
  // data() {
  //   return {
  //     log: null
  //   };
  // },
  watch: {
    activeStep() {
      let ref = this.$refs["wizard-step-wrap"];
      // console.log("REFF > ", ref);
      if (ref) {
        this.scrollToTop(ref.offsetTop - 100);
      } else {
        this.scrollToTop(300);
      }
    }
  },
  methods: {
    scrollToTop(top = 0) {
      window.scrollTo({ top, behavior: "smooth" });
    },
    nextStep() {
      this.$emit("next-step");
    },
    lastStep() {
      this.$emit("last-step");
    }
  },
  computed: {
    isFinalStep() {
      return this.wizard.activeStep === this.wizard.totalSteps;
    }
  }
};
</script>

<style lang="stylus">
.wizard
  // overflow hidden
  min-height 300px
  marg('3xl', bottom)
  &.is-loading
    position relative
    &:after
      content ''
      position absolute
      top 0
      left 0
      bottom 0
      right 0
      background rgba(#fff, 0.8)
      z-index 1111111111
  // & > :not(.preloader):first-child
  //   border-bottom 1px solid gray_4
  .wizard-active-step
    min-height 36vh
    overflow-y auto
    overflow-x hidden
    position relative
    transition all 0.4s ease-out
    // max-height 90vh
    .required-fields-note
      position absolute
      top 5px
      left 0
      color gray_6
  &.popped-layout .wizard-active-step
    max-height 40vh
  h5 i
    font-size responsive 18px 28px
    color blue_brand

.out-of-box
  position absolute
  bottom 0
  right 0
  transform translate(0, 150%)
</style>
